import safewayLogoWhite from "@/assets/safeway-logo-white.png";
import { usePhoneBar } from "@/contexts/PhoneBarContext";

const towns = [
  "Bay Shore", "Babylon", "Brentwood", "Commack", "Deer Park", "East Hampton",
  "East Islip", "Freeport", "Garden City", "Great Neck", "Hempstead", "Huntington",
  "Islip", "Lawrence", "Levittown", "Lindenhurst", "Massapequa", "Northport",
  "Patchogue", "Riverhead", "Ronkonkoma", "Sayville", "Smithtown", "West Islip",
];

export const AdsServiceAreaFooter = () => {
  const { phoneNumber } = usePhoneBar();
  const formattedPhone = phoneNumber.replace("+1", "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

  return (
    <footer className="bg-foreground text-background py-12">
      <div className="container mx-auto px-4 max-w-4xl text-center">
        <img src={safewayLogoWhite} alt="Safeway Roofing" className="h-12 w-auto mx-auto mb-6" />
        <h3 className="text-lg font-bold mb-2">Serving Long Island & Beyond</h3>
        <div className="flex flex-wrap justify-center gap-x-3 gap-y-1 text-sm opacity-60 mb-8">
          {towns.map((t) => (
            <span key={t}>{t}</span>
          ))}
        </div>
        <a href={`tel:${phoneNumber}`} className="text-lg font-bold text-primary hover:underline">
          {formattedPhone}
        </a>
        <p className="text-xs opacity-50 mt-6">
          © {new Date().getFullYear()} Safeway Roofing & Siding. All rights reserved. Licensed & Insured.
        </p>
      </div>
    </footer>
  );
};
